/**
 * Created by Carsten Bühler
 * User: CBuehler on 25.09.2015
 * Copyright: xdot GmbH 2015
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';

import { FormControl } from 'external/react-bootstrap';
import 'external/react-datepicker-css';
import DatePicker from 'external/react-datepicker';

const handleChange = ({ date, onChange }) => {
    onChange && onChange({ date });
};

const DateTimeFormComponent = props => {
    let { minDate, maxDate, startDate, onChange, inline, label, popperPlacement = 'auto' } = props;

    startDate = startDate ? new Date(startDate) : new Date();
    minDate = minDate ? new Date(minDate) : null;
    maxDate = maxDate ? new Date(maxDate) : null;

    props = {
        ...props,
        inline: props.inlineCal, /* inline is used by React Bootstrap and DatePicker */
        minDate,
        maxDate,
        startDate
    };

    return (
        <div className={inline ? 'react-datepicker-inline' : ''}>
            <span className={'datepicker-date'}>
                {
                    label && <span className={'datepicker-label'}>{label}</span>
                }
                <DatePicker
                    {...props}
                    selected={startDate}
                    popperPlacement={popperPlacement}
                    selectsStart
                    allowSameDay
                    onChange={date => handleChange({ date, onChange })}
                />
            </span>
        </div>
    );
};

const DateTimePicker = props => <FormControl {...props} as={DateTimeFormComponent}/>;

//https://reactdatepicker.com/ & https://github.com/Hacker0x01/react-datepicker/blob/master/src/index.jsx
DateTimePicker.propTypes = {
    onChange: PropTypes.func,
    inline: PropTypes.bool,
    startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    label: PropTypes.node,
    timeFormat: PropTypes.string,
    timeCaption: PropTypes.string,
    popperPlacement: PropTypes.oneOf([
        'auto'
        , 'auto-start'
        , 'auto-end'
        , 'top'
        , 'top-start'
        , 'top-end'
        , 'bottom'
        , 'bottom-start'
        , 'bottom-end'
        , 'right'
        , 'right-start'
        , 'right-end'
        , 'left'
        , 'left-start'
        , 'left-end'
    ])
};

DateTimePicker.defaultProps = {
    dateFormat: 'dd.MM.yyyy HH:mm',
    timeFormat: 'HH:mm',
    timeCaption: 'Uhrzeit'
};

DateTimeFormComponent.propTypes = DateTimePicker.propTypes;

export default DateTimePicker;



// WEBPACK FOOTER //
// ./js/components/DateTimePicker.jsx